module.exports = {"370102001":"解放路街道","370102002":"千佛山街道","370102003":"趵突泉街道","370102004":"泉城路街道","370102005":"大明湖街道","370102006":"东关街道","370102007":"文东街道","370102008":"建新街道","370102009":"甸柳街道","370102010":"燕山街道","370102011":"姚家街道","370102012":"龙洞街道","370102013":"智远街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370102.json
// module id = 1351
// module chunks = 0